import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/actions/Button'
import useUser from '../../../../contexts/hooks/useUser'

interface Props {
	setSmartChargingPolicy: ({
		hashedPid,
		vehicleId,
		options,
	}: {
		hashedPid: string
		vehicleId: string
		options: {
			isEnabled: boolean
			deadline: string
		}
	}) => void
	vehicle: ENodeVehicle | null | undefined
}
const SmartChargingToggle = ({ setSmartChargingPolicy, vehicle }: Props) => {
	const { user } = useUser()

	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'smartChargingVisualiser' })

	return (
		<div className='smart-charging p-2'>
			<div className='toggle-container'>
				{!vehicle?.smartChargingPolicy.isEnabled ? (
					<Button
						className='m-0 p-1'
						// className='hollow m-0 border bg-white dark:bg-brand-secondary-200-dark border-brand-primary-100-light dark:border-brand-primary-100-dark px-8 rounded-full w-fit mx-auto'

						onClick={() =>
							setSmartChargingPolicy({
								vehicleId: vehicle?.id ?? '',
								hashedPid: user?.hashedPid ?? '',
								options: {
									isEnabled: true,
									deadline: vehicle?.smartChargingPolicy.deadline ?? '08:00',
								},
							})
						}
					>
						{t('aktivoi')}
					</Button>
				) : (
					<Button
						// className='hollow m-0 border bg-white dark:bg-brand-secondary-200-dark border-brand-primary-100-light dark:border-brand-primary-100-dark px-8 rounded-full w-fit mx-auto'
						className='m-0 p-1'
						onClick={() =>
							setSmartChargingPolicy({
								vehicleId: vehicle.id,
								hashedPid: user?.hashedPid ?? '',
								options: {
									isEnabled: false,
									deadline: vehicle?.smartChargingPolicy.deadline ?? '08:00',
								},
							})
						}
					>
						{t('deactivate')}
					</Button>
				)}
			</div>
		</div>
	)
}

export default SmartChargingToggle
